const platform = {
    title: 'Platform settings',
    subtitle: 'Manage cross-tenant administrators and global platform appearance.',
    branding_title: 'Platform branding',
    branding_description: 'Applied to the Console, authentication, account center, demos, and help center.',
    product_name: 'Product name',
    slogan: 'Slogan',
    light_logo: 'Light theme logo',
    dark_logo: 'Dark theme logo',
    upload_logo: 'Upload logo',
    uploading: 'Uploading…',
    logo_uploaded: 'Logo uploaded',
    hide_open_source_notice: 'Hide open-source notice',
    hide_open_source_notice_description: 'Hide visible attribution links while retaining required license and source files.',
    save: 'Save changes',
    saving: 'Saving…',
    saved: 'Platform branding saved',
    administrators_title: 'Platform administrators',
    administrators_description: 'Platform administrators can manage every tenant and all instance-level settings.',
    administrator_identifier_placeholder: 'User ID, username, or email',
    add_administrator: 'Add administrator',
    administrator_added: 'Platform administrator added',
    remove_administrator: 'Remove platform administrator',
};
export default Object.freeze(platform);
